import React from 'react'

const Social = () => {
  return (
    <div className="home__social" data-aos="fade-right" data-aos-duration="1500">
        <a href="https://www.linkedin.com/in/damar-galih-7b5a1124b/" className="home__social-icon" target="_blank" rel="noreferrer">
            <i className="uil uil-linkedin-alt"></i>
        </a>
        {/* <a href="https://www.instagram.com/invites/contact/?i=1qn7f0ctoxn2r&utm_content=4rioy6h" className="home__social-icon" target="_blank" rel="noreferrer">
            <i className="uil uil-instagram"></i>
        </a> */}
        <a href="https://github.com/damar-glh" className="home__social-icon" target="_blank" rel="noreferrer">
            <i className="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social